import {calcVisibleViolations} from './violations.utils';
import {CartModel} from '../models/Cart/Cart.model';
import {CartSummaryModel} from '../models/CartSummary/CartSummary.model';
import {ViolationModel} from '../models/CartSummary/Violation.model';
import {getUniques} from './getUniques';

const BI_AMOUNT_MULTIPLIER = 100000;
export const toBiAmount = (amount: number) => Math.round(amount * BI_AMOUNT_MULTIPLIER);

export const getCatalogAppIds = (cartModel: CartModel): string => {
  return getMappedUniqueList(cartModel?.lineItems, ({source}) => source.catalogReference?.appId || 'no-catalog-app-id');
};

export const getItemTypes = (cartModel: CartModel): string => {
  return getMappedUniqueList(cartModel.lineItems, ({attributes}) => attributes.itemType);
};

function getMappedUniqueList<T>(arr: T[] | undefined, mapper: (t: T) => string | undefined | null): string {
  return getUniques((arr ?? /* istanbul ignore next */ []).map(mapper).filter(isDefined)).toString();
}

const isDefined = <T>(obj: T): boolean => {
  return !!obj;
};

export const getAdditionalFeesPrice = (cartSummary: CartSummaryModel): number => {
  return toBiAmount(cartSummary?.priceSummary?.additionalFees?.convertedAmount ?? 0);
};

export const getValidations = (violations: ViolationModel[]): string | undefined => {
  if (violations?.length > 0) {
    const top3violations = calcVisibleViolations(violations);
    const biViolations = top3violations.map((violation) => {
      return {
        type: violation.severity,
        is_line_item: Boolean(violation.target?.lineItemTarget?.id),
        message: violation.description,
        name: violation.target?.otherTarget?.name || violation.target?.lineItemTarget?.name,
      };
    });

    return JSON.stringify(biViolations);
  }

  return undefined;
};

export const getNumberOfAdditionalFees = (cartSummary: CartSummaryModel): number => {
  return cartSummary?.additionalFees?.length || 0;
};

export const getItemsCount = (cartModel: CartModel): number => {
  return cartModel?.lineItems.reduce((count, lineItem) => count + lineItem.quantityInfo.quantity, 0) || 0;
};
